module.exports = __webpack_public_path__ + "img/alert-icon-info.65c7c5f4.svg";